import { ConsentsActions, ConsentsActionTypes } from '../actions/consentsActions';
import { BffUserConsentsResponse } from '@lucky7ventures/bff-types';

export interface ConsentsState {
  consents: BffUserConsentsResponse;
  consentsLoading: boolean;
  consentsSuccess: boolean;
  consentsError: boolean;
  updateConsentsLoading: boolean;
  updateConsentsSuccess: boolean;
  updateConsentsError: boolean;
}

const initialState = {
  consents: [],
  consentsLoading: false,
  consentsSuccess: false,
  consentsError: false,
  updateConsentsLoading: false,
  updateConsentsSuccess: false,
  updateConsentsError: false,
};

export const consentsReducer = (state = initialState, action: ConsentsActions): ConsentsState => {
  switch (action.type) {
    case ConsentsActionTypes.GetConsents:
      return {
        ...state,
        consentsLoading: true,
        consentsError: false,
      };
    case ConsentsActionTypes.GetConsentsSuccess:
      return {
        ...state,
        consents: action.consents,
        consentsSuccess: true,
        consentsLoading: false,
        consentsError: false,
      };
    case ConsentsActionTypes.GetConsentsError:
      return {
        ...state,
        consentsLoading: false,
        consentsError: true,
      };
    case ConsentsActionTypes.UpdateConsents:
      return {
        ...state,
        updateConsentsLoading: true,
        updateConsentsError: false,
      };
    case ConsentsActionTypes.UpdateConsentsSuccess:
      return {
        ...state,
        consents: action.consents,
        updateConsentsSuccess: true,
        updateConsentsLoading: false,
        updateConsentsError: false,
      };
    case ConsentsActionTypes.UpdateConsentsError:
      return {
        ...state,
        updateConsentsLoading: false,
        updateConsentsError: true,
      };
    case ConsentsActionTypes.ResetConsents:
      return initialState;
    default:
      return state;
  }
};
